import { BackendApiInstance } from "../config/Interceptor";
import Api from "./../config/Api";
export function getSellerDetails() {
  return BackendApiInstance.get(`${Api.getSellerDetails}`);
}
